import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UtilsState {
  show: boolean;
}

const initialState: UtilsState = {
  show: false,
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setShow: (state, action: PayloadAction<boolean>) => {
      state.show = action.payload;
    },
  },
});

export const { setShow } = utilsSlice.actions;
export default utilsSlice.reducer;
